import { ReferralMatchVerification } from './referral-match-verification.model';

export class AbstractReferralMatchOption {
  constructor(
    public verification: ReferralMatchVerification,
    public selected: boolean,
    public disabled: boolean
  ) {}
}
